<template>
    <div class="empty">
        <img src="./img/empty.png"
             class="pic" />
        <p class="text">{{text}}</p>
    </div>
</template>

<script type="text/ecmascript-6">
export default {
    props: {
        text: {
            default: "暂无数据",
            type: String
        }
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.empty {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 50px 0;
    .pic {
        width: 180px;
        height: 180px;
        margin-bottom: 20px;
    }
    .text {
        color: #666;
        font-size: 14px;
        text-align: center;
    }
}
</style>